import { narrativeStatus } from '@helpers/narratives';

export const DEFAULT_ASSISTANT_MESSAGE = {
  content: '**Welcome to Numerator Narratives.**\n\nAsk a business question to get started.',
  id: 'assistant-welcome',
  role: 'assistant',
};

export const DEFAULT_DRAFT_NARRATIVE_NAME = 'Untitled Narrative';
export const CHAT_RESPONSE_POLL_INTERVAL_MS = 1000;
export const CHAT_RESPONSE_POLL_MAX_ATTEMPTS = 15;
export const MAX_CHAT_MESSAGE_LENGTH = 25000;
export const CHAT_MESSAGE_LENGTH_ERROR = 'Message exceeds the character limit.';
export const CHAT_INPUT_DISCLAIMER =
  'Do not submit personal data, health information, third-party confidential information, or unlawful or infringing content.';
export const MAX_TOPIC_CARDS = 12;

export const PAGES = {
  CHAT: 'chat',
  LANDING: 'landing',
  PAST_PROJECTS: 'past-projects',
  TEMPLATES: 'templates',
  TOPICS: 'topics',
  WORKSPACE_TEMPLATES: 'workspace-templates',
};

export const WORKSPACE_PAGES = new Set([
  PAGES.CHAT,
  PAGES.PAST_PROJECTS,
  PAGES.TOPICS,
  PAGES.WORKSPACE_TEMPLATES,
]);

export const FLOW_FINISHED_STATUSES = new Set([
  narrativeStatus.COMPLETED,
  narrativeStatus.EXCEPTION,
]);
